import Repository from '../repositories/referalProgram'; 
class PostAfiliatesUtilites {

    constructor() {
        this.postAfilitateScriptLink = process.env.VUE_APP_POSTAFFILIATEPRO_SCRIPT_LINK;
        this.postAfiliateScriptId = process.env.VUE_APP_POSTAFFILIATE_SCRIPT_ID;
    }

    clickTracking(referrer_id,postAfiliateCampaingId,postAfiliateBannerId) {
        
            const postAffScript = document.createElement("script");
            postAffScript.setAttribute(
              "src",
              this.postAfilitateScriptLink
            );
            postAffScript.setAttribute("id",this.postAfiliateScriptId);
            postAffScript.addEventListener("load", ()=>{
                window.PostAffTracker.setAccountId('default1');
                window.BannerID=postAfiliateBannerId;
                window.CampaignID=postAfiliateCampaingId;
                window.AffiliateID = referrer_id;
                try {
                  window.PostAffTracker.track();
                // eslint-disable-next-line no-console
                } catch (err){console.error('Error in click tracking:', err);}
              })
            document.body.appendChild(postAffScript);
          
    }
    registerTracking(referrer_id,postAfiliateCampaingId,userEmail){
        const postAffScript = document.createElement("script");
        postAffScript.setAttribute(
          "src",
          this.postAfilitateScriptLink
        );
        postAffScript.setAttribute("id",this.postAfiliateScriptId);
        postAffScript.addEventListener("load", ()=>{
          var registerAction = window.PostAffTracker.createAction('register');
            registerAction.setCampaignID(postAfiliateCampaingId);
            registerAction.setOrderID(userEmail);
            registerAction.setProductID('app.swiset/register');
            registerAction.setTotalCost('0');
            registerAction.setAffiliateID(referrer_id);
            window.PostAffTracker.register();
        })
        document.body.appendChild(postAffScript);
    }
    paymentTracking(referrer_id,postAfiliateCampaingId, session_reference, amount){
      const postAffScript = document.createElement("script");
      postAffScript.setAttribute(
          "src",
          this.postAfilitateScriptLink
      );
      postAffScript.setAttribute("id",this.postAfiliateScriptId);
      postAffScript.addEventListener("load", ()=>{
          window.PostAffTracker.setAccountId('default1');
          var saleAction = window.PostAffTracker.createSale();
          saleAction.setCampaignID(postAfiliateCampaingId);
          saleAction.setOrderID(session_reference);
          saleAction.setTotalCost(amount);
          saleAction.setProductID('app.swiset/register');
          saleAction.setAffiliateID(referrer_id);
          window.PostAffTracker.register();
      })
      document.body.appendChild(postAffScript);
    }
    async checkReferrer(referrer){
        await Repository.getReferrer(referrer).then((response) => {
            return response.data;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error.message);
            return false;
        });
    }
}

export default new PostAfiliatesUtilites();
